import React from "react";
import "./Footer.css";

export default function Header(props) {
  return (
    <div className="footer">
      <p>{props.note}</p>
    </div>
  );
}
